import compontent from './component'
const addroutes=(data)=>{
    let addroutes=[];
    if(data&&data.length>0){
      let levelonedata={
        path:'/',
        component:compontent.Home,
        name:''
      }
      levelonedata.children=[]
        data.forEach(element => {
      
         if(element.submenu&&element.submenu.length>0){
           
           let leveltwodata={}
           element.submenu.forEach(item=>{
             if(item.link){
              let leveltwodata={
                path:item.link,
                name:item.name,
                component:compontent[item.link]
             }
             levelonedata.children.push(leveltwodata)
            }
            if(item.submenu&&item.submenu.length>0){
              let levelthrdata={}
                 item.submenu.forEach(value=>{
                   if(value.link){
                    let levelthrdata={
                      path:value.link,
                      name:value.name,
                      compontent:compontent[value.link]
                    }
                    levelonedata.children.push(levelthrdata)
                   }
                   

                 })
                 
             }
             
      
               
           })
         }
         
         
        });
        addroutes.push(levelonedata)
    }
    
    addroutes.push(
           {
          path: '*',
          hidden: true,
          redirect: {
            path: '/404'
          }
        })
     return addroutes
}

export default addroutes;



// WEBPACK FOOTER //
// ./src/constant/addroutes.js